import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import Axios from "axios";
import LoadingSpinner from "../helpers/loadingspinner";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import ReactPaginate from "react-paginate";
import nodataimg from "../assets/images/Nodata.jpg";
import { ChangeHotLsitStatus, GetHotList } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";
import Swal from 'sweetalert2';

const ListOfHotList = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [jobPosts, setJobPosts] = useState([]);
    const [filteredJobPosts, setFilteredJobPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(25);
    const [toggle, setToggle] = useState(true);
    const [jobTypeInput, setJobTypeInput] = useState("");
    const [statusFilter, setStatusFilter] = useState("1");
    const [countryFilter, setCountryFilter] = useState("");
    const [typeFilter, setTypeFilter] = useState("");
    const [tiertypeFilter, setTierTypeFilter] = useState("");

    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showIcon, setShowIcon] = useState('list');
    const [viewType, setViewType] = useState('list'); // 'grid' or 'list'
    let Guid="";
    const guid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const token = localStorage.getItem("jwtToken")
    const roleID = localStorage.getItem("roleID")
    const {selectedCountry} = useCountry();
    if(roleID==3){
     Guid = employerGuid
    }
    else{
      Guid= guid
    }
    const navigate = useNavigate();
    const handleViewToggle = (type) => {
      setViewType(type);
      setShowIcon(type)
    };
        
    useEffect(() => {
        fetchJobPosts();
       
    }, [selectedCountry]);

    useEffect(() => {
        filterJobPosts();
    }, [toggle, jobPosts, jobTypeInput, statusFilter,countryFilter,typeFilter,viewType,tiertypeFilter]);

    const handleSelectAll = () => {
      if (selectAll) {
        setSelectedItems([]);
      } else {
        const filteredItemsWithEmail = jobPosts.filter(item => item.emailId);
        setSelectedItems(filteredItemsWithEmail);
      }
      setSelectAll(!selectAll);
    };
    
    const handleForwardClick = () => {
      localStorage.setItem('SelectedSubVendorList', JSON.stringify(selectedItems));
    navigate('SelectedSubVendorList');
    };

   const handleUserStatus = (hotListID, isActive) => {
    const newIsActive = !isActive;
    const type = newIsActive ? 1 : 0;

    const APIURL = `${ChangeHotLsitStatus.APIURL}?hotListID=${hotListID}&type=${type}`;

    setIsLoading(true);

    Axios.put(APIURL, {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then((result) => {
        setJobPosts(prevJobPosts =>
            prevJobPosts.map(jobPost =>
                jobPost.hotListID === hotListID ? { ...jobPost, isActive: newIsActive } : jobPost
            )
        );

        setIsLoading(false);

        if (result.data.message === "Hot List Activated successfully.") {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Activated Successfully',
                showConfirmButton: false,
                timer: 5000,
            });
        } else if (result.data.message === "Hot List Deactivated successfully.") {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Deactivated Successfully',
                showConfirmButton: false,
                timer: 5000,
            });
        }
    })
    .catch((error) => {
        console.error("Error: ", error);
        setIsLoading(false);

        Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to update hot list status.',
            confirmButtonText: 'OK'
        });
    });
};


    function strip_html_tags(str) {
      if ((str === null) || (str === 'undefined' || str === undefined))
          return false;
      else
          str = str.toString();
      str = str.replace(/<[^>]*>/g, '');
      return substring_str(str.replace('&nbsp;', '').replace('.&nbsp;', ''));
  }

  function substring_str(str) {
      if ((str === null) || (str === ' ' || str === undefined))
          return "";
      else
          str = str.toString();
      return str.substring(0, 50) + "...";
  }
    const fetchJobPosts = async () => {
        setIsLoading(true);
        try {
          const response = await Axios.get(`${GetHotList.APIURL}?UserGuid=${guid}&countryId=${selectedCountry}`,
          {            headers: {
              Authorization: `Bearer ${token}`
            }
          }
          );
            setJobPosts(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error("Error fetching hot list", error);
            setIsLoading(false);
        }
    };

    const filterJobPosts = () => {
        let filtered = jobPosts;
    
        // Apply job title search filter
        if (jobTypeInput) {
            filtered = filtered.filter((x) => x.name?.toLowerCase().includes(jobTypeInput.toLowerCase())||
            x.description?.toLowerCase().includes(jobTypeInput.toLowerCase())||
            x.emailId?.toLowerCase().includes(jobTypeInput.toLowerCase())||
            x.company?.toLowerCase().includes(jobTypeInput.toLowerCase()));
    
        }
    
        // Apply status filter if selected
        if (statusFilter == "1") {
            filtered = filtered.filter((x) => x.isActive == 1);
        } else if (statusFilter == "0") {
            filtered = filtered.filter((x) => x.isActive == 0);
            
        }
        if (countryFilter == "India") {
          filtered = filtered.filter((x) => x.country == "India");
      } else if (countryFilter == "United States") {
          filtered = filtered.filter((x) => x.country == "United States");
          
      }
      if (typeFilter == "Recruiter") {
        filtered = filtered.filter((x) => x.type == "Recruiter");
    } else if (typeFilter == "BenchSales") {
        filtered = filtered.filter((x) => x.type == "BenchSales");
        
    }
     if (tiertypeFilter == "Tier 1") {
        filtered = filtered.filter((x) => x.tierType == "Tier 1");
    } else if (tiertypeFilter == "Tier 2") {
        filtered = filtered.filter((x) => x.tierType == "Tier 2");
    }else if (tiertypeFilter == "Tier 3") {
        filtered = filtered.filter((x) => x.tierType == "Tier 3");
    }
        // Apply pagination

    
        setFilteredJobPosts(filtered);
        setCurrentPage(0)
    };

    const handleCheckboxChange = (item) => {
      const selectedIndex = selectedItems.findIndex(selectedItem => selectedItem.hotListID === item.hotListID);
  
      if (selectedIndex === -1) {
          setSelectedItems([...selectedItems, item]);
      } else {
          const updatedItems = [...selectedItems];
          updatedItems.splice(selectedIndex, 1);
          setSelectedItems(updatedItems);
      }
  };

    const handlePageClick = (e) => {
        setCurrentPage(e.selected);
    };


    const handleJobTypeInputChange = (e) => {
        setJobTypeInput(e.target.value);
    };

    const handleStatusFilterChange = (e) => {
        setStatusFilter(e.target.value);
    };

    const handleCountryFilterChange = (e) => {
      setCountryFilter(e.target.value);
  };
  const handleTypeFilterChange = (e) => {
    setTypeFilter(e.target.value);
};

const handletierTypeFilterChange = (e) => {
    setTierTypeFilter(e.target.value);
};
    const offset = currentPage * itemsPerPage;
    const currentItems = filteredJobPosts.slice(offset, offset + itemsPerPage);

    return (
        <ConsultantLayout>
            <div className="container-fluid mt-4 pb-5">

                <div className="responsive-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className="" style={{ color: "#00a7ac" }}>Staffing Contacts</h2>
          <div style={{ display: 'flex', alignItems: 'center' }}>
             
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
              <label style={{ marginLeft: '5px',marginRight:20 }}>Select All</label>
              {showIcon === 'grid' && (
               <OverlayTrigger placement="bottom" overlay={<Tooltip>List View</Tooltip>}>
                 <button
                   className="btn btn-primary mr-3"
                   onClick={() => handleViewToggle('list')}
                   style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                 >
                   <i className="fa fa-th-list" style={{ color: '#fff', fontSize: "16px" }}></i>
                 </button>
               </OverlayTrigger>
             )}
           
             {showIcon === 'list' && (
               <OverlayTrigger placement="bottom" overlay={<Tooltip>Grid View</Tooltip>}>
                 <button
                   className="btn btn-primary mr-3"
                   onClick={() => handleViewToggle('grid')}
                   style={{ backgroundColor: "#00a7ac", height: "38px", width: "38px", display: "flex", justifyContent: "center", alignItems: "center" }}
                 >
                   <i className="fa fa-th" style={{ color: '#fff', fontSize: "16px" }}></i>
                 </button>
               </OverlayTrigger>
             )}
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Add Staffing Contact</Tooltip>)}>
                <Link to="/Employer/AddStaffingContact">
                  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-plus"></i></button>
                </Link>
              </OverlayTrigger>
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Import Staffing Contacts</Tooltip>)}>
              <Link to="/Employer/AddBulkSubVendorList">
              <button className="btn btn-primary mr-3" type="button" >
              <i class="fas fa-upload"></i>
                </button>
                </Link></OverlayTrigger>
        </div>
   


                </div>
                {selectedItems.length > 0 && selectedItems.some(item => item.emailId) && (
  <div style={{ textAlign: 'right', marginTop: '10px' }}>
    <button className="btn btn-primary" onClick={handleForwardClick}>
      <i className="fa fa-arrow-right"></i> Send Email
    </button>
  </div>
)}
                <div className="mt-3" style={{ display: 'flex', gap: '10px' }}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Search by Name or Email or Company or Key skills</Tooltip>)}>

                    <input
                        type="text"
                        className="form-control"
                        placeholder="Search by Name or Email or Company Name or Key skills"
                        value={jobTypeInput}
                        onChange={handleJobTypeInputChange}
                        style={{ flex: '1',height:50, fontSize:14 }}
                    />
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Search by Activated / DeActivated Staffing Contact</Tooltip>)}>

                    <select
                        className="form-control"
                        value={statusFilter}
                        onChange={handleStatusFilterChange}
                        style={{ flex: '1' ,height:50, fontSize:14}}
                    >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-active</option>
                    </select>
                 


</OverlayTrigger>
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Search by Type</Tooltip>)}>

<select
    className="form-control"
    value={typeFilter}
    onChange={handleTypeFilterChange}
    style={{ flex: '1' ,height:50, fontSize:14}}
>
    <option value="">Select Type</option>
    <option value="Recruiter">Recruiter</option>
    <option value="BenchSales">BenchSales</option>
</select>
</OverlayTrigger>

  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Search by Tier Type</Tooltip>)}>

<select
    className="form-control"
    value={tiertypeFilter}
    onChange={handletierTypeFilterChange}
    style={{ flex: '1' ,height:50, fontSize:14}}
>
    <option value="">Select Tier Type</option>
    <option value="Tier 1">Tier 1</option>
    <option value="Tier 2">Tier 2</option>
    <option value="Tier 3">Tier 3</option>

</select>
</OverlayTrigger>
                </div>
                <hr />

                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <div>
                         {viewType === 'grid' ? (
                        <div className="row mt-5">
                          
                            {currentItems.map((data) => {
                               const isSelected = selectedItems.some(item => item.hotListID === data.hotListID);
return(
                              
                                     <div key={data.hotListID} className="col-sm-12 col-md-6 col-xl-4 col-lg-4 pb-3">
                                     <div className="card" style={{ background: "#f8f8f8", border: '1px solid #00a7ac26', maxHeight: 620, height: 480, borderRadius: 20 }}>
                                     <div className='card-header' style={{ background: "none", minHeight: 140 }}>
              <div className='row'>
                <div className='col-8'>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Name</Tooltip>)}>
                    <p className="card-title jb-head" style={{ color: "#00a7ac", fontSize: 24 }}><b>{data.name}</b></p>
                  </OverlayTrigger>
               {data.company !=''&&   <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Company Name</Tooltip>)}>
                    <h5 style={{ fontSize: 18 }}>{data.company}</h5>
                  </OverlayTrigger>}

                </div>
                <div className='col-4'>
                 
                </div>
              </div>
            </div>
            <div className="card-body">
     
            <OverlayTrigger 
      placement="bottom" 
      overlay={(props) => (
        <Tooltip id="tooltip" {...props}>Phone Number</Tooltip>
      )}
    >
      <div className='whatsapp' style={{ display: 'flex', alignItems: 'center' }}>
        {/* Phone Number Link */}
        <a 
          href={`tel:${data.phoneNumber}`} 
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginRight: 10 }}
        >
          <i 
            style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} 
            className="fa fa-mobile" 
            aria-hidden="true"
          ></i>
          <p style={{ fontSize: 14, textAlign: 'justify', margin: 0, color: 'inherit' }}>
            {data.phone}
          </p>
        </a>

        {/* WhatsApp Link */}
        <a 
          href={`https://wa.me/${data.phone}`} 
          target="_blank" 
          rel="noopener noreferrer" 
          style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
        >
          <i 
            style={{ fontSize: 20, color: "#00a7ac", marginLeft: 8 }} 
            className="fab fa-whatsapp-square" 
            aria-hidden="true"
          ></i>
          <p style={{ fontSize: 14, textAlign: 'justify', margin: 0,marginLeft:6, color: 'inherit' }}>
            Whatsapp
          </p>
        </a>
      </div>
    </OverlayTrigger>
       {
  data.emailId !='' &&  data.emailId != null && data.emailId!='null' && (
    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Email</Tooltip>)}>
      <a href={`mailto:${data.emailId}`} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', marginRight: 10, marginBottom:10}}>
        <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-envelope" aria-hidden="true"></i>
        <p style={{ fontSize: 14, textAlign: 'justify', margin: 0, color: 'inherit'}}>{data.emailId}</p>
      </a>
    </OverlayTrigger>
  )
}
  {data.website !='' &&  data.website != null && data.website!='null' &&    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Website URL</Tooltip>)}>
              <a 
            href={data.website?.startsWith('http') ? data.website : `https://${data.website}`} 
            target="_blank" 
            rel="noopener noreferrer"
        >
            <p className="text-para"  style={{ fontSize: 14}}>
           
                {/* <i className="fa fa-globe mt-2"></i> */}
                <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }} className="fa fa-globe mt-2" aria-hidden="true"></i>{data.website}
                
            </p>
        </a>         
            </OverlayTrigger>}

            {data.tierType !='' &&  data.tierType != null && data.tierType!='null' && ( 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Tier Type</Tooltip>)}>

               <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-map-marker mt-2" aria-hidden="true"></i> {data.tierType} </p>
            </OverlayTrigger> )}

            {data.type !='' &&  data.type != null && data.type!='null' && ( 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Type</Tooltip>)}>

               <p style={{ fontSize: 14, textAlign: 'justify' }}><i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-user mt-2" aria-hidden="true"></i> {data.type} </p>
            </OverlayTrigger> )}
      
           {data.description !=''&& 
            <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Description</Tooltip>)}>
                                                 <p style={{ fontSize: 14 }}>
                                                     <i style={{ fontSize: 14, color: "#00a7ac", marginRight: 10 }} className="fa fa-align-left mt-2" aria-hidden="true"></i> {strip_html_tags(data.description)}
                                                 </p>
                                             </OverlayTrigger>}
              </div>
              <div className='card-footer d-flex justify-content-between'>
                <Link style={{}} to={"/Employer/EditStaffingContact?HotListID=" + data.hotListID}>
                  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Edit</Tooltip>)}>
                    <button style={{ background: "none", border: "none" }}><i className="fa fa-edit" aria-hidden="true" style={{ fontSize: 18 ,marginTop :10, color: "#00a7ac" }}></i></button>
                  </OverlayTrigger>
                  </Link>
                  <Link style={{}} to={"/Employer/ViewStaffingContact?data=" + data.hotListID}>
                                                     <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>View</Tooltip>)}>
                                                         <button style={{ background: "none", border: "none" }}>
                                                             <i className="fa fa-eye" aria-hidden="true" style={{ fontSize: 20,marginTop :10, color: "#00a7ac" }}></i>
                                                         </button>
                                                     </OverlayTrigger>
                                                 </Link>
                
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> {data.isActive ? 'Deactivate Staffing Contact' : 'Activate Staffing Contact'}</Tooltip>)}>
               <button className="mt-1"
               onClick={() => handleUserStatus(data.hotListID, data.isActive) }style={{ background: "none", border: "none" }}>
              <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} aria-hidden="true" style={{ fontSize: 18, color: "#00a7ac" }}></i>
              </button>
 
                
               </OverlayTrigger>
{data.emailId && (
  <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select</Tooltip>)}>
    <input
    style={{marginTop:4}}
      type="checkbox"
      checked={isSelected}
      onChange={() => handleCheckboxChange(data)}
    />
  </OverlayTrigger>
)}

              </div>
            
          </div>

                                     </div>
                                
)})}
                        </div>)
                         : 
                         (  <div className="col-12" style={{ overflowX: "auto", width: "100%" }}>
                              <table
  className="table"
  style={{
    minWidth: "100%",
    fontSize: "12px", // Reduced font size
    // tableLayout: "fixed",
    wordWrap: "break-word",
  }}
>
  <thead>
    <tr>
      <th style={{ padding: "6px" }}>Name</th>
      <th style={{ padding: "6px" }}>Company</th>
      <th style={{ padding: "6px" }}>Phone Number</th>
      <th style={{ padding: "6px" }}>Email</th>
      <th style={{ padding: "6px" }}>Website URL</th>
       <th style={{ padding: "6px" }}>Tier Type</th>
      {/* <th style={{ padding: "6px" }}>Type</th> */} 
      <th style={{ padding: "6px" }}>Description</th>
      <th style={{ padding: "6px", minWidth: "100px" }}>Actions</th>
    </tr>
  </thead>
  <tbody>
    {currentItems?.map((data, index) => {
      const isSelected = selectedItems.some(item => item.hotListID === data.hotListID);
      return (
        <tr key={index}>
          <td>{data.name}</td>
          <td>{data.company}</td>
          <td style={{ width: "120px" }}>
            <div className="whatsapp" style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              {/* Phone Number Link */}
              <a
                href={`tel:${data.phoneNumber}`}
                style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
              >
                <i className="fa fa-mobile" style={{ fontSize: 14, color: "#00a7ac", marginRight: 5 }}></i>
                <span style={{ fontSize: 12 }}>{data.phone}</span>
              </a>
              {/* WhatsApp Link */}
              <a
                href={`https://wa.me/${data.phone}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
              >
                <i className="fab fa-whatsapp-square" style={{ fontSize: 18, color: "#00a7ac", marginRight: 5 }}></i>
                <span style={{ fontSize: 12 }}>Whatsapp</span>
              </a>
            </div>
          </td>
          <td style={{ maxWidth: '130px', wordBreak: 'break-word' }}>{data.emailId}</td>
          <td>
            {(data.website && data.website !== 'null') && (
              <a
                href={data.website.startsWith('http') ? data.website : `https://${data.website}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <span style={{ fontSize: 12, color: "#00a7ac" }}>
                  <i className="fa fa-globe" style={{ marginRight: 5 }}></i>
                  {data.website}
                </span>
              </a>
            )}
          </td>
          <td>{data.tierType}</td>
          {/* <td>{data.type}</td> */}
          <td style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {strip_html_tags(data.description)}
          </td>
          <td>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", justifyContent: "center" }}>
              {/* Edit */}
              <Link to={`/Employer/EditStaffingContact?HotListID=${data.hotListID}`}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Edit</Tooltip>)}>
                  <button style={{ background: "none", border: "none", padding: "4px" }}>
                    <i className="fa fa-edit" style={{ fontSize: 16, color: "#00a7ac" }}></i>
                  </button>
                </OverlayTrigger>
              </Link>

              {/* View */}
              <Link to={`/Employer/ViewStaffingContact?data=${data.hotListID}`}>
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>View</Tooltip>)}>
                  <button style={{ background: "none", border: "none", padding: "4px" }}>
                    <i className="fa fa-eye" style={{ fontSize: 16, color: "#00a7ac" }}></i>
                  </button>
                </OverlayTrigger>
              </Link>

              {/* Activate/Deactivate */}
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>{data.isActive ? 'Deactivate' : 'Activate'}</Tooltip>)}>
                <button
                  onClick={() => handleUserStatus(data.hotListID, data.isActive)}
                  style={{ background: "none", border: "none", padding: "4px" }}
                >
                  <i className={`fa fa-${data.isActive ? 'toggle-on' : 'toggle-off'}`} style={{ fontSize: 16, color: "#00a7ac" }}></i>
                </button>
              </OverlayTrigger>

              {/* Checkbox */}
              {data.emailId && (
                <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Select</Tooltip>)}>
                  <input
                    type="checkbox"
                    style={{ marginTop: 4 }}
                    checked={isSelected}
                    onChange={() => handleCheckboxChange(data)}
                  />
                </OverlayTrigger>
              )}
            </div>
          </td>
        </tr>
      );
    })}
  </tbody>
</table>

                                                    </div>)}
                        {filteredJobPosts.length === 0 && (
                            <div style={{ textAlign: 'center' }}>
                                <img src={nodataimg} alt="No Data" style={{ width: '100%', maxWidth: '500px' }} />
                            </div>
                        )}
                    </div>
                )}

{filteredJobPosts.length > itemsPerPage && (
                         <ReactPaginate
                         previousLabel={"Prev"}
                         nextLabel={"Next"}
                         breakLabel={"..."}
                         breakClassName={"break-me"}
                         pageCount={Math.ceil(filteredJobPosts.length / itemsPerPage)}
                         marginPagesDisplayed={2}
                         pageRangeDisplayed={5}
                         onPageChange={handlePageClick}
                         containerClassName={"pagination"}
                         subContainerClassName={"pages pagination"}
                         activeClassName={"active"}
                         disabledClassName={"disable-pagination-button"}
                     />
                        )}
                    
                        </div>
        </ConsultantLayout>
    );
};

export default ListOfHotList;



